module.exports = __webpack_public_path__ + "static/media/anc4kz.5aebde71.pdf";